<template>
  <div class="flex max-w-full mb-5 bg-white rounded shadow-lg">
    <div class="flex flex-col justify-between w-full p-6 md:flex-row">
      <div class="flex grow">
        <div class="w-16 h-16 mr-4 mr-6 shrink-0 md:w-28 md:h-28">
          <CSkeleton class="bg-gray-200" theme="opacity" height="100%" duration="2" />
        </div>

        <div class="w-full md:max-w-2/3">
          <CSkeleton class="mb-3 bg-gray-200" theme="opacity" height="20px" duration="2" />
          <CSkeleton class="mb-2 text-xs bg-gray-200" theme="opacity" height="12px" duration="2" />
          <CSkeleton class="mb-2 text-xs bg-gray-200" theme="opacity" height="12px" width="90%" duration="2" />
          <CSkeleton class="mb-2 text-xs bg-gray-200" theme="opacity" height="12px" width="30%" duration="2" />
        </div>
      </div>
      <div class="md:mt-0 md:ml-4 md:w-44 md:self-end">
        <CSkeleton class="mt-2 bg-gray-200 rounded-3xl" theme="opacity" height="40px" duration="2" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<script lang="ts">
export default defineComponent({
  name: 'ProductSkeletonTile',
});
</script>
